import image from './image'
import places from './places'
import Map from './map'
import Overlay from './overlay'

export default {
    ...google.maps,
    Map,
    Overlay,
    places,
    image
}


